import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ActiveInactiveFor, BusinessEnabledOption, InteractionType, KeyValues5, KeyValueSet, LocalService, NumericConfig, Status } from 'src/service/local.service';
import { ProductManagementService } from 'src/service/product-management.service';

@Component({
  selector: 'app-batch-inventories',
  templateUrl: './batch-inventories.component.html',
  styleUrl: './batch-inventories.component.scss'
})
export class BatchInventoriesComponent {
  ctryCode: string = ''; userId = ''; interactionType: InteractionType = InteractionType.None; businessId: string = ''; productId: string = '';
  maxBodyHeight = 0; isOnlyActive = true; isBatchPricingPopupOpen = false; selectedBatchId: string = '';

  numericConfig: NumericConfig = { isDecimalAllowed: true, isNegativeAllowed: true } as NumericConfig;

  items: KeyValues5[] = []; isDirectStockDisabled: boolean = false;

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private productManagementService: ProductManagementService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.businessId = routeParams.businessId;
      this.productId = routeParams.id;
      this.userId = routeParams.userId;
      this.ctryCode = routeParams.ctryCode;

      this.onLoad();
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    setTimeout(() => {
      this.isDirectStockDisabled = this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.DisableDirectStockEntry);
      this.productManagementService.getBatchTitleWithInventory(this.productId, this.isOnlyActive).subscribe(result => {
        this.items = result;
      });
    }, 100);
  }

  isProcessing = false;
  onAddStock(event, key, currentVal) {
    if (!this.isProcessing) {
      if (event.target.value != null && event.target.value != '') {
        const data = { key: this.productId, value: event.target.value, s_value: key } as KeyValueSet;
        this.isProcessing = true;
        this.productManagementService.addStock(data).subscribe(result => {
          this.localService.showInformationByStatus(result.status, result.status != Status.Success);
          if (result.status == Status.Success) {
            this.items.find(x => x.v1 == key).v2 = (parseFloat(currentVal) + parseFloat(event.target.value)).toString();
            event.target.value = null;
          }
          this.isProcessing = false;
        });
      }
    }
  }

  onActiveInactiveStatus(strId: string) {
    this.productManagementService.activeInactiveStatus(strId, ActiveInactiveFor.ProductBatchInventory).subscribe(result => {
      if (result.status == Status.Success) {
        const updatedItem = this.items.find(x => x.key == strId);
        updatedItem.v4 = result.id;
      }
    });
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        this.selectedBatchId = key;
        this.isBatchPricingPopupOpen = true;
      } break;
    }
  }
}
